<template>
  <div class="forum-post-container">
    <el-card class="forum-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>{{ isEdit ? '编辑帖子' : '发布帖子' }}</span>
      </div>
      <el-form :model="postForm" :rules="rules" ref="postFormRef" label-width="80px">
        <el-form-item label="分类" prop="categoryId">
          <el-select v-model="postForm.categoryId" placeholder="请选择论坛分类">
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="postForm.title" placeholder="请输入帖子标题"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :rows="10"
            v-model="postForm.content"
            placeholder="请输入帖子内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ForumPost',
  data() {
    return {
      isEdit: false,
      postId: null,
      postForm: {
        title: '',
        content: '',
        categoryId: null
      },
      categories: [
        { id: 1, name: '游戏讨论' },
        { id: 2, name: '约战大厅' },
        { id: 3, name: '战术分享' },
        { id: 4, name: '地图更新' },
        { id: 5, name: '投诉建议' }
      ],
      rules: {
        title: [
          { required: true, message: '请输入帖子标题', trigger: 'blur' },
          { min: 2, max: 100, message: '标题长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入帖子内容', trigger: 'blur' },
          { min: 2, message: '内容长度不能少于 2 个字符', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择论坛分类', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.postId = this.$route.params.id
    if (this.postId) {
      this.isEdit = true
      this.fetchPostDetail()
    }
    this.fetchCategories()
  },
  methods: {
    fetchCategories() {
      this.$axios.get('/forum/category/list').then(res => {
        this.categories = res.data
      })
    },
    fetchPostDetail() {
      this.$axios.get(`/forum/post/detail/${this.postId}`).then(res => {
        this.postForm = res.data
      })
    },
    submitForm() {
      this.$refs.postFormRef.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.updatePost()
          } else {
            this.createPost()
          }
        } else {
          return false
        }
      })
    },
    createPost() {
      // 添加用户ID（从localStorage获取或使用默认值）
      const user = JSON.parse(localStorage.getItem('user'))
      const postData = {
        ...this.postForm,
        userId: user ? user.id : 2 // 使用默认用户ID 2（player1）
      }
      
      this.$axios.post('/forum/post/create', postData).then(res => {
        this.$message.success('发帖成功')
        this.$router.push('/forum')
      }).catch(error => {
        console.error('Create post error:', error)
        this.$message.error('发帖失败，请重试')
      })
    },
    updatePost() {
      // 添加用户ID（从localStorage获取或使用默认值）
      const user = JSON.parse(localStorage.getItem('user'))
      const postData = {
        ...this.postForm,
        userId: user ? user.id : 2 // 使用默认用户ID 2（player1）
      }
      
      this.$axios.put(`/forum/post/update/${this.postId}`, postData).then(res => {
        this.$message.success('编辑成功')
        this.$router.push(`/forum/detail/${this.postId}`)
      }).catch(error => {
        console.error('Update post error:', error)
        this.$message.error('编辑失败，请重试')
      })
    },
    resetForm() {
      this.$refs.postFormRef.resetFields()
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.forum-post-container {
  padding: 20px 0;
}

.forum-card {
  margin-bottom: 20px;
}
</style>